<template>
    <rkm-modal
        extraLarge
        ref="RkmModal"
        title="Parametrização da cota do prestador"
    >
        <Form
            :data="data"
            :index="index"
            :item="item"
            ref="Form"
            @save="handleExit"
            @novaCota="verificaCota"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                {{ novaCota ? 'Cancelar' : 'Fechar' }}
            </rkm-button>
            <rkm-button v-if="novaCota" color="success" @click="handleSave">
                Confirmar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './components/Form'

export default {
    components: { Form },
    data: () => ({
        index: null,
        item: null,
        novaCota: false
    }),
    methods: {
        open(index, item) {

            this.index = index

            if(item){

                this.item = item
            }

            this.$refs.RkmModal.show()
        },
        handleExit(data) {

            this.$emit('save', data)
        },
        handleSave() {
            this.$refs.Form.save()
            this.$refs.RkmModal.hide()
        },
        verificaCota(value) {
            this.novaCota = value;
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>